import { SVGProps, Ref, forwardRef } from 'react';

export const StarHalfFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1c-1.333 0-2.12 1.887-3.692 5.662l-.35.84-.867.07C3.015 7.9.977 8.064.565 9.333c-.412 1.268 1.14 2.599 4.244 5.26l.628.54-.204.855c-.946 3.978-1.419 5.967-.34 6.75s2.824-.28 6.315-2.41l.766-.467.767.468c3.49 2.129 5.236 3.193 6.315 2.41 1.078-.784.605-2.773-.34-6.751l-.196-.82.67-.574c3.104-2.662 4.656-3.993 4.244-5.261S20.984 7.9 16.91 7.572l-.867-.07-.35-.84C14.12 2.887 13.333 1 12 1m0 16.77 1.678 1.023c1.797 1.096 2.975 1.81 3.837 2.18.364.158.374.15.337-.244-.087-.935-.401-2.276-.888-4.323l-.449-1.888 1.504-1.29c1.598-1.37 2.64-2.27 3.26-2.975.261-.297.257-.31-.129-.396-.915-.206-2.288-.322-4.386-.491l-1.961-.159-.772-1.853c-.81-1.943-1.344-3.213-1.823-4.02-.1-.17-.154-.255-.208-.255z"
                fill="currentColor"
            />
        </g>
    </svg>
));
StarHalfFilledSize24Glyph.displayName = 'StarHalfFilledSize24Glyph';
